import React from "react";

// Need to append rs-icon to custom icons to provide proper interactity with expanded sidenav
const NavCustomIcon = ({ IconComponent, className = "", ...props }) => {
  return <IconComponent className={`rs-icon ${className}`} {...props} />;
};

export default NavCustomIcon;
